// extracted by mini-css-extract-plugin
export var container = "lpFaqSection-module--container--dad31";